import React, { useState, useEffect } from "react";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import { Link, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { Create_Api } from "../../ApiUrls";

function ForgotPassword() {
  const navigate = useNavigate()
  const [Email, setEmail] = useState("");
  const [Otp, setOtp] = useState("");
  const [GeneratedOtp, setGeneratedOtp] = useState("");
  const [IsUploading, setIsUploading] = useState(false);

  const [ShowOtp, setShowOtp] = useState(false);
  const [ShowPassword, setShowPassword] = useState(false);
  const [NewPassword, setNewPassword] = useState("");
  const [ConfirmPassword, setConfirmPassword] = useState("");

  const sendOtp = async () => {
    if (!Email) {
      toast.error("Email is Required");
      return;
    }

    const otp = Math.floor(1000 + Math.random() * 9000).toString();
    setGeneratedOtp(otp);

    try {
      setIsUploading(true);
      let data = { Email, otp };
      const response = await Create_Api("api/user/ForgotPasswordSendEmailOtp", data);
      toast.success(response?.message || "OTP sent successfully!");
      setShowOtp(true);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error sending OTP");
    } finally {
      setIsUploading(false);
    }
  };

  // Verify OTP
  const verifyOtp = () => {
    if (!Otp) {
      toast.error("Please enter the OTP");
      return;
    }

    if (Otp !== GeneratedOtp) {
      toast.error("Invalid OTP, please try again");
      return;
    }

    toast.success("OTP verified successfully!");
    setShowOtp(false)
    setShowPassword(true);
  };

  const resetPassword = async () => {
    if (!NewPassword || !ConfirmPassword) {
      toast.error("Please enter and confirm your new password");
      return;
    }

    if (NewPassword !== ConfirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      setIsUploading(true);
      let data = { Email, Password: NewPassword };
      const response = await Create_Api("api/user/ForgotUserPasswordUpdate", data);
      toast.success(response?.message || "Password reset successfully!");
      navigate('/login')
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error resetting password");
    } finally {
      setIsUploading(false);
    }
  };





  return (
    <>
      <Navbar />
      <div className="login-div">
        <div className="login-form">
          <div className="login-form-left">

          </div>
          <div className="login-form-right">
            <div className="noacc">
              <p>Welcome to <span>Hostess</span></p>
            </div>
            <br />
            <h3>Forgot Password</h3>
            <br />
            <div className="tab-container">
              <br />
              <br />
              <>
                  <label>Enter Email</label>
                  <input
                    placeholder="Enter email address"
                    value={Email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={ShowOtp || ShowPassword}
                  />
                  <br />
                  {!ShowOtp && !ShowPassword && (
                    <>
                      <br />
                      <div className="forget">
                        <button onClick={sendOtp} disabled={IsUploading}>
                          {IsUploading ? "Sending OTP..." : "Send OTP"}
                        </button>
                      </div>
                    </>
                  )}

                  {ShowOtp && (
                    <>
                      <br />
                      <label>Verification Code</label>
                      <input
                        placeholder="Enter Code"
                        value={Otp}
                        onChange={(e) => setOtp(e.target.value)}
                      />
                      <br />
                      <br />
                      <div className="forget">
                        <button onClick={verifyOtp}>Verify OTP</button>
                      </div>
                    </>
                  )}

                  {ShowPassword && (
                    <>
                      <br />
                      <label>New Password</label>
                      <input
                        type="password"
                        placeholder="Enter new password"
                        value={NewPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <br />
                      <br />
                      <label>Confirm Password</label>
                      <input
                        type="password"
                        placeholder="Confirm new password"
                        value={ConfirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      <br />
                      <br />
                      <div className="forget">
                        <button onClick={resetPassword} disabled={IsUploading}>
                          {IsUploading ? "Updating..." : "Reset Password"}
                        </button>
                      </div>
                    </>
                  )}
              </>
            </div>
            <br />
          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}

export default ForgotPassword